import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { VideoComponentStrapi } from '@core/const';
import { PromoService } from '@promo/data-access';
import { SafeResourceUrlPipe } from '@sdvor/shared/ui';
import { filter, map, Observable } from 'rxjs';

@Component({
  selector: 'sd-banner-video',
  imports: [AsyncPipe, SafeResourceUrlPipe],
  templateUrl: './banner-video.component.html',
  styleUrls: ['./banner-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerVideoComponent {
  bannerVideo$: Observable<VideoComponentStrapi | undefined> = this.promoService.getPromo().pipe(
    filter((promo) => !!promo),
    map((promo) => promo.video),
  );

  isLoading$: Observable<boolean> = this.promoService.getPromoLoading();

  constructor(private promoService: PromoService) {}
}
